import { classNames } from 'libs/react';
import { useRef } from 'libs/react';
import { Button } from 'components/Button';
import { React } from 'libs/react';
import './MediaUploadButton.scss';
/**
 * @component MediaUploadButton
 * @since 1.0.0
 */
export function MediaUploadButton(props) {
    const { style, types } = Object.assign({ style: 'normal', types: '' }, props);
    const input = useRef(null);
    /**
     * @function onUpload
     * @since 1.0.0
     * @hidden
     */
    function onUpload() {
        if (input.current) {
            input.current.value = '';
            input.current.click();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(e) {
        const files = input.current && input.current.files;
        if (files && props.onUpload) {
            props.onUpload(Array.from(files));
        }
    }
    const className = classNames('media-upload-button', 'media-upload-button--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "media-upload-button-value" },
            React.createElement("input", { ref: input, name: "file", type: "file", multiple: true, accept: types, onChange: onChange })),
        React.createElement("div", { className: "media-upload-button-input" },
            React.createElement(Button, { picto: "upload", label: t('Upload'), onPress: onUpload, style: "outline" }))));
}
